import React from 'react';

export const SmileEmoji = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9609 27.2849C22.1741 27.2849 27.2109 22.2481 27.2109 16.0349C27.2109 9.82171 22.1741 4.78491 15.9609 4.78491C9.74773 4.78491 4.71094 9.82171 4.71094 16.0349C4.71094 22.2481 9.74773 27.2849 15.9609 27.2849Z"
        fill="url(#paint0_radial_10778_989)"
      />
      <path
        d="M15.9609 27.2849C22.1741 27.2849 27.2109 22.2481 27.2109 16.0349C27.2109 9.82171 22.1741 4.78491 15.9609 4.78491C9.74773 4.78491 4.71094 9.82171 4.71094 16.0349C4.71094 22.2481 9.74773 27.2849 15.9609 27.2849Z"
        fill="url(#paint1_radial_10778_989)"
      />
      <path
        d="M15.9648 27.2539C22.178 27.2539 27.2148 22.2171 27.2148 16.0039C27.2148 9.7907 22.178 4.75391 15.9648 4.75391C9.75164 4.75391 4.71484 9.7907 4.71484 16.0039C4.71484 22.2171 9.75164 27.2539 15.9648 27.2539Z"
        fill="url(#paint2_radial_10778_989)"
        fillOpacity="0.8"
      />
      <path
        d="M15.9648 4.75391C9.75164 4.75391 4.71485 9.7907 4.71485 16.0039C4.71485 22.2171 9.75164 27.2539 15.9648 27.2539C22.178 27.2539 27.2148 22.2171 27.2148 16.0039C27.2148 9.7907 22.1781 4.75391 15.9648 4.75391Z"
        fill="url(#paint3_radial_10778_989)"
        fillOpacity="0.8"
      />
      <g opacity="0.4" filter="url(#filter0_f_10778_989)">
        <path
          d="M21.7421 8.45479C21.7421 10.0699 19.1765 11.3792 16.0117 11.3792C12.8468 11.3792 10.2812 10.0699 10.2812 8.45479C10.2812 6.83969 12.8468 5.5304 16.0117 5.5304C19.1765 5.5304 21.7421 6.83969 21.7421 8.45479Z"
          fill="url(#paint4_radial_10778_989)"
        />
      </g>
      <path
        d="M14.1883 14.0857C14.6554 14.0857 14.5435 9.84265 12.3131 9.84265C10.0827 9.84265 10.0456 13.9823 10.5714 14.0273C11.0973 14.0723 10.8959 11.9367 12.3131 11.9367C13.7302 11.9367 13.7213 14.0857 14.1883 14.0857Z"
        fill="url(#paint5_radial_10778_989)"
      />
      <path
        d="M14.1883 14.0857C14.6554 14.0857 14.5435 9.84265 12.3131 9.84265C10.0827 9.84265 10.0456 13.9823 10.5714 14.0273C11.0973 14.0723 10.8959 11.9367 12.3131 11.9367C13.7302 11.9367 13.7213 14.0857 14.1883 14.0857Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5642 14.2689C14.5007 14.3502 14.3763 14.4607 14.1883 14.4607C13.9674 14.4607 13.8202 14.3287 13.7395 14.2282C13.6593 14.1284 13.5997 14.0059 13.5533 13.8985C13.5095 13.7971 13.4663 13.6817 13.4244 13.5697C13.4204 13.5589 13.4163 13.5481 13.4123 13.5373C13.3651 13.4114 13.3172 13.2851 13.263 13.1605C13.0364 12.6386 12.774 12.3117 12.3131 12.3117C12.0681 12.3117 11.9117 12.398 11.7895 12.5273C11.6544 12.6702 11.5514 12.8773 11.4603 13.1272C11.4177 13.2442 11.3807 13.3617 11.3431 13.4806L11.3375 13.4984C11.2996 13.6187 11.2591 13.7463 11.2145 13.8583C11.1719 13.9653 11.1121 14.0942 11.0207 14.1981C10.9184 14.3143 10.7558 14.4194 10.5395 14.4009C10.3761 14.387 10.2622 14.2953 10.195 14.2167C10.1286 14.1392 10.0844 14.0491 10.0536 13.9686C9.99134 13.8059 9.95393 13.6025 9.93458 13.3882C9.8954 12.9544 9.92331 12.3949 10.0419 11.8397C10.16 11.2874 10.3746 10.7072 10.7324 10.2569C11.0988 9.79584 11.6207 9.46765 12.3131 9.46765C13.0085 9.46765 13.5342 9.80512 13.906 10.272C14.2702 10.7291 14.4961 11.3183 14.6274 11.8787C14.7593 12.442 14.8027 13.0076 14.7805 13.4418C14.7696 13.656 14.7418 13.8581 14.6903 14.0181C14.6653 14.0961 14.627 14.1886 14.5642 14.2689ZM12.3131 9.84265C14.5435 9.84265 14.6554 14.0857 14.1883 14.0857C14.018 14.0857 13.911 13.7998 13.775 13.4367C13.5381 12.804 13.2134 11.9367 12.3131 11.9367C11.4368 11.9367 11.1794 12.7531 10.9862 13.3657C10.8669 13.7439 10.7721 14.0445 10.5714 14.0273C10.0456 13.9823 10.0827 9.84265 12.3131 9.84265Z"
        fill="url(#paint6_linear_10778_989)"
      />
      <path
        d="M17.9601 14.0857C17.4931 14.0857 17.605 9.84265 19.8354 9.84265C22.0658 9.84265 22.1029 13.9823 21.577 14.0273C21.0511 14.0723 21.2525 11.9367 19.8354 11.9367C18.4182 11.9367 18.4271 14.0857 17.9601 14.0857Z"
        fill="url(#paint7_radial_10778_989)"
      />
      <path
        d="M17.9601 14.0857C17.4931 14.0857 17.605 9.84265 19.8354 9.84265C22.0658 9.84265 22.1029 13.9823 21.577 14.0273C21.0511 14.0723 21.2525 11.9367 19.8354 11.9367C18.4182 11.9367 18.4271 14.0857 17.9601 14.0857Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5842 14.2689C17.6478 14.3502 17.7722 14.4607 17.9601 14.4607C18.181 14.4607 18.3282 14.3287 18.409 14.2282C18.4891 14.1284 18.5487 14.0059 18.5951 13.8985C18.6389 13.7971 18.6821 13.6817 18.724 13.5697C18.7281 13.5589 18.7321 13.5481 18.7362 13.5373C18.7833 13.4114 18.8313 13.2851 18.8854 13.1605C19.112 12.6386 19.3745 12.3117 19.8354 12.3117C20.0803 12.3117 20.2367 12.398 20.3589 12.5273C20.4941 12.6702 20.597 12.8773 20.6881 13.1272C20.7307 13.2442 20.7678 13.3617 20.8053 13.4806L20.8109 13.4984C20.8489 13.6187 20.8893 13.7463 20.9339 13.8583C20.9765 13.9653 21.0364 14.0942 21.1278 14.1981C21.23 14.3143 21.3927 14.4194 21.609 14.4009C21.7723 14.387 21.8862 14.2953 21.9535 14.2167C22.0199 14.1392 22.0641 14.0491 22.0949 13.9686C22.1571 13.8059 22.1945 13.6025 22.2139 13.3882C22.253 12.9544 22.2251 12.3949 22.1065 11.8397C21.9885 11.2874 21.7738 10.7072 21.416 10.2569C21.0497 9.79584 20.5277 9.46765 19.8354 9.46765C19.14 9.46765 18.6143 9.80512 18.2424 10.272C17.8783 10.7291 17.6523 11.3183 17.5211 11.8787C17.3892 12.442 17.3457 13.0076 17.3679 13.4418C17.3789 13.656 17.4067 13.8581 17.4581 14.0181C17.4832 14.0961 17.5214 14.1886 17.5842 14.2689ZM19.8354 9.84265C17.605 9.84265 17.4931 14.0857 17.9601 14.0857C18.1304 14.0857 18.2374 13.7998 18.3734 13.4367C18.6103 12.804 18.935 11.9367 19.8354 11.9367C20.7116 11.9367 20.9691 12.7531 21.1623 13.3657C21.2815 13.7439 21.3763 14.0445 21.577 14.0273C22.1029 13.9823 22.0658 9.84265 19.8354 9.84265Z"
        fill="url(#paint8_linear_10778_989)"
      />
      <path
        d="M9.29131 15.6449C9.09337 15.538 8.8486 15.647 8.85562 15.8718C8.91605 17.809 10.8403 22.1922 15.9858 22.1922C21.237 22.1922 23.2367 18.2195 23.1455 16.0582C23.1365 15.8442 22.904 15.7356 22.7098 15.8259C19.7132 17.2189 12.3862 17.3158 9.29131 15.6449Z"
        fill="#3F1C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.80295 15.2417C9.01944 15.1348 9.27975 15.1414 9.49917 15.2599C10.949 16.0426 13.4649 16.4364 16.0392 16.4469C18.6104 16.4573 21.1144 16.0851 22.5254 15.4292C22.7437 15.3277 22.9917 15.3341 23.1959 15.4383C23.4072 15.5461 23.5709 15.7613 23.5826 16.0397C23.6833 18.4257 21.5092 22.6297 15.9858 22.6297C13.2722 22.6297 11.3865 21.4675 10.1798 20.041C8.98773 18.6318 8.4518 16.9581 8.41834 15.8855C8.40911 15.5899 8.575 15.3542 8.80295 15.2417ZM8.85562 15.8718C8.84861 15.647 9.09338 15.538 9.29132 15.6449C12.3862 17.3158 19.7132 17.2189 22.7098 15.8259C22.904 15.7356 23.1365 15.8443 23.1455 16.0582C23.2367 18.2195 21.237 22.1922 15.9858 22.1922C10.8403 22.1922 8.91606 17.809 8.85562 15.8718Z"
        fill="url(#paint9_linear_10778_989)"
      />
      <path
        d="M19.4561 21.4822C19.1376 20.6667 17.7119 20.0522 16.0016 20.0522C14.3332 20.0522 12.9488 20.6317 12.5781 21.4111C13.4696 21.8705 14.5418 22.1664 15.8163 22.1906C15.8778 22.1916 15.9397 22.1921 16.002 22.1922C17.3666 22.1901 18.5112 21.9195 19.4561 21.4822Z"
        fill="url(#paint10_radial_10778_989)"
      />
      <path
        d="M22.4864 15.9379C22.4864 16.7756 21.8165 18.7282 16.0222 18.7282C10.2272 18.7282 9.55859 16.6004 9.55859 15.9379C9.55859 15.8842 9.55997 15.8322 9.56268 15.7817C12.7153 17.2715 19.4534 17.1852 22.4864 15.9242C22.4864 15.9288 22.4864 15.9334 22.4864 15.9379Z"
        fill="white"
      />
      <path
        d="M22.4864 15.9379C22.4864 16.7756 18.956 17.3126 16.0222 17.3126C13.0884 17.3126 9.55859 16.6004 9.55859 15.9379C9.55859 15.8842 9.55997 15.8322 9.56268 15.7817C12.7153 17.2715 19.4534 17.1852 22.4864 15.9242C22.4864 15.9288 22.4864 15.9334 22.4864 15.9379Z"
        fill="url(#paint11_radial_10778_989)"
      />
      <defs>
        <filter
          id="filter0_f_10778_989"
          x="7.44923"
          y="2.69837"
          width="17.125"
          height="11.5129"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.41601"
            result="effect1_foregroundBlur_10778_989"
          />
        </filter>
        <radialGradient
          id="paint0_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.631 6.1309) scale(21.0305)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.43" stopColor="#FFD400" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FF8E00" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(12.8919 18.2106 -18.2098 12.8488 10.8666 6.5542)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.608798" stopColor="#FFE437" stopOpacity="0" />
          <stop offset="0.858784" stopColor="#FF79B1" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF3673" stopOpacity="0.56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.9648 16.5162) rotate(-90) scale(12.3762 11.8236)"
        >
          <stop offset="0.848958" stopColor="#FFC60C" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7039" stopOpacity="0.68" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.9648 15.4916) rotate(90) scale(11.7623 11.6637)"
        >
          <stop offset="0.847356" stopColor="#FE789B" stopOpacity="0" />
          <stop offset="1" stopColor="#F11414" stopOpacity="0.41" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0117 8.45479) rotate(89.9999) scale(2.92439 5.37628)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#FFED49" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.352 13.8599) rotate(-86.4952) scale(4.23716 7.64)"
        >
          <stop offset="0.196185" stopColor="#842200" />
          <stop offset="1" stopColor="#C63800" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_10778_989"
          x1="12.352"
          y1="9.50377"
          x2="10.8466"
          y2="13.324"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0345786" stopColor="#FD9E28" />
          <stop offset="1" stopColor="#FFDF90" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.7964 13.8599) rotate(-93.5048) scale(4.23716 7.64)"
        >
          <stop offset="0.196185" stopColor="#842200" />
          <stop offset="1" stopColor="#C63800" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_10778_989"
          x1="19.7964"
          y1="9.50377"
          x2="21.3019"
          y2="13.324"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0345786" stopColor="#FD9E28" />
          <stop offset="1" stopColor="#FFDF90" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10778_989"
          x1="16.002"
          y1="15.6035"
          x2="16.002"
          y2="22.1922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD9E28" stopOpacity="0.4" />
          <stop offset="1" stopColor="#FFF2B7" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0171 20.0522) rotate(90.0008) scale(2.34113 5.10971)"
        >
          <stop stopColor="#FF7193" />
          <stop offset="0.421875" stopColor="#FF71A4" />
          <stop offset="1" stopColor="#EF164A" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_10778_989"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-7.24217 0.127054 1.0938 -47.5637 16.2157 16.7761)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C9C9C9" />
          <stop offset="1" stopColor="#D2D2D2" stopOpacity="0.6" />
        </radialGradient>
      </defs>
    </svg>
  );
};
